import { Component, EventEmitter, OnChanges, OnInit, Output } from '@angular/core';

import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { Message } from '../models/message';
import { MessagesService } from '../services/messages.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
})
export class MessagesComponent implements OnInit,OnChanges {
  columns:any;
  rows:any;
  messages:Message[] = [];;
  searchKey: string;
  p: number = 1;
  @Output() displayName: EventEmitter<any> = new EventEmitter();
  constructor(private mainService:MessagesService,private authService:AuthenticationService) { }

  ngOnInit() {
    // this.displayName.emit("Messages");
    // this.columns = [{'name':'Username'},{'name':'recipient'},{'name':'date_sent'},{'name':'message'}]
    let details = this.authService.getUserDetails();
    this.mainService.getMessages(details['user']).subscribe(data=>{
      this.messages=data['results']
      console.log(this.messages,"----------------------------------->")
    })


    //pull messages
    //Display in a reusable table
    //Allow pagination
    //reeusable datasource
    //Links in messages should be clickable


  }
  ngOnChanges() {

    this.ngOnInit();
  }
  // open(item:Message){
  //  let data=item.split(" ");
  //  let count=0
  //  for(let i in data){
  //    if("@" in i){
  //    let url = i;

  //    }
  //  }

  // }

}
